import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (!this.element.value) {
      this.element.value = window.location.href
    }
  }
}
